import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-table-pagination',
  templateUrl: './table-pagination.component.html',
  styleUrl: './table-pagination.component.scss',
})
export class TablePaginationComponent {
  @Input('totalRecords') totalRecords: any;
  @Input('pageSize') pageSize: any;
  @Output() onPaginateChange = new EventEmitter<any>();
  @Input() resetPageIndex: boolean = false;
  startIndex: number = 0;
  length: number = 0;
  @ViewChild(MatPaginator) paginatorRef!: MatPaginator;
  constructor(
    private paginator: MatPaginatorIntl,
    private translate: TranslateService
  ) {
    this.setRangeLabel()
    this.translate.onLangChange.subscribe(() => {
      this.setRangeLabel();
      this.paginator.changes.next(); // Notify the paginator to refresh labels
    });
  }

  firstPage(): void {
    if (this.paginatorRef) {
      this.paginatorRef.firstPage();
    }
  }

  setRangeLabel() {
    this.paginator.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number
    ): string => {
      if (length === 0) {
        return this.translate.instant('constants.PAGINATOR.PAGE_EMPTY');
      }
      this.length = Math.ceil(length / pageSize);
      const currentPage = page + 1;
      const totalPages = this.length;

      return this.translate.instant('constants.PAGINATOR.RANGE_LABEL', {
        currentPage,
        totalPages,
      });
    };

    // Update static labels dynamically
    this.translate.get([
      'constants.PAGINATOR.ITEMS_PER_PAGE',
      'constants.PAGINATOR.NEXT_PAGE',
      'constants.PAGINATOR.PREVIOUS_PAGE',
    ]).subscribe((translations) => {
      this.paginator.itemsPerPageLabel = translations['constants.PAGINATOR.ITEMS_PER_PAGE'];
      this.paginator.nextPageLabel = translations['constants.PAGINATOR.NEXT_PAGE'];
      this.paginator.previousPageLabel = translations['constants.PAGINATOR.PREVIOUS_PAGE'];
    });
  }

  ngAfterViewInit() {
    // Observe changes to the paginator label and apply bold styling
 
  }
  onChangePage(event: PageEvent) {
    this.onPaginateChange.emit(event);
  }
}
